<div class="tableWrap table-separator" [class.tblLoading]="showLoader">
    <table *ngIf="(gaTable | keyvalue)?.length" class="iso_info_tbl">
        <thead>
            <tr>
                <th *ngFor="let heading of gaTable.head" scope="col">{{heading.title}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let cont of gaTable.content; let last = last;">
                <ng-container *ngIf="last; then lastRow else withoutLastRow"></ng-container>
                <ng-template #withoutLastRow>
                    <tr>
                        <td *ngFor="let heading of gaTable.head;"> 
                            <span class="td_loading"></span>
                            <!-- Display hyphon when  the value is null -->
                            <span class="td_content">{{cont[heading.id] === null ? '' : cont[heading.id]}}<span *ngIf="heading?.id == '6kHz' && cont['line']=='a' && tdh39Amendment == true">*</span></span>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #lastRow>
                    <tr class="lastRow">
                        <td scope="col" *ngFor="let heading of gaTable.head;">
                            <span class="td_loading"></span>
                            <span class="td_content">{{cont[heading.id] === null ? '' : cont[heading.id]}}</span>
                        </td>
                    </tr>
                </ng-template>
            </ng-container>
        </tbody>
    </table>
</div>
<!-- <div class="alert mt-2 rounded-0">
    <div>{{gaTable.symbolData}}</div>
</div> -->